import axios from "axios"
import Server from "util/Server"

export const getSicomStates = async () => {
    return axios.get(Server.host! + Server.puerto_reporte_service + '/api/monitor-sicom/obtener/estado-sicom', {
        headers: {
            Authorization: Server.obtenerToken()
        }
    })
}